export function isPlaque(item) {
    return item?.type === "Plaque";
}
export function isEngravedPlaque(item) {
    return item?.type === "EngravedPlaque";
}
export function isPreviousYearPlaque(item) {
    return item?.type === "PreviousYearPlaque";
}
//# sourceMappingURL=plaque.js.map